<template lang="pug">
section.promo
  .promo__video
    video(preload="auto", muted="", autoplay="", loop="", data-keepplaying="")
      source(src="~@/assets/video/bg.webm", type="video/webm")
      source(src="~@/assets/video/bg.mp4", type="video/mp4")
  .promo__content
    PromoHead(
      :isUserInProject="isUserInProject"
      :activityKey="activityKey"
      :openReg="openReg"
      :balance="userBalance"
      :maxReplenishCount="maxReplenishCount"
      :currentReplenishCount="currentReplenishCount"
      :replenishPrice="replenishPrice"
      :replenishAmount="replenishAmount"
      @updatePromoAfterReplenish="updatePromoAfterReplenish"
    )
    .promo__body
      LootBoxes(
        v-if="isUserInProject && chestOffers && frontendSettings"
        :activityKey="activityKey"
        :balance="userBalance"
        :chestOffers="chestOffers"
        :chestLinks="frontendSettings.chestLinks"
        @decreaseBalance="decreaseBalance"
      )
      .scroll_challenges
      Challenges(
        v-if="isUserInProject && questsArray && frontendSettings"
        :challenges="questsArray"
        :challengeGroups="frontendSettings.questGroups"
      )
      Faq#faq
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";
import PromoHead from "./blocks/PromoHead";
import LootBoxes from "./blocks/LootBoxes";
import Challenges from "./blocks/Challenges";
import Faq from "./blocks/Faq";

const { mapGetters } = createNamespacedHelpers("global");

export default {
  name: "Promo",

  components: {
    PromoHead,
    LootBoxes,
    Challenges,
    Faq,
  },

  mixins: [MobileDetection],

  data() {
    return {
      activityKey: "quests-with-rating",
      frontendSettings: null,
      userBalance: null,
      replenishPrice: null,
      replenishAmount: null,
      maxReplenishCount: null,
      currentReplenishCount: null,
      questsArray: null,
      chestOffers: null,
    }
  },

  computed: {
    ...mapGetters(["isUserInProject", "isUserNotAuthed", "isUserAuthedNotRegistered"]),
  },

  mounted() {
    document.addEventListener("auth_done", () => {
      this.fetchAll()
    });
  },

  methods: {
    updatePromoAfterReplenish() {
      this.currentReplenishCount--;
      this.userBalance += this.replenishAmount;
    },
    decreaseBalance(price) {
      this.userBalance -= price;
    },
    fetchAll() {
      this.getEventInfo();
      this.getShopState();
      this.getFrontendSettings();
    },
    getFrontendSettings() {
      this.$api.minigamesService
        .getActivityByKey(this.activityKey)
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.frontendSettings = response.data.result.frontend_settings;
          }
        });
    },
    getEventInfo() {
      this.$api.questsWithRatingService
        .info(this.activityKey)
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.questsArray = response.data.result.quests;
            this.currentReplenishCount = response.data.result.exchanges_left;
            this.userBalance = response.data.result.balance;
          }
        });
    },
    getShopState() {
      this.$api.questsWithRatingService
        .shopState(this.activityKey)
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.maxReplenishCount = response.data.result.exchange_daily_count;
            this.replenishPrice = response.data.result.exchange_price;
            this.replenishAmount = response.data.result.exchange_amount;
            this.chestOffers = response.data.result.chests;
          }
        });
    },
    openReg() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
  },
};
</script>
